
/* injects from baggage-loader */

'use strict';

import cashierSearchDirective from './cashierSearch.directive';
import cashierSearchConstant from './cashierSearch.constant';
/**
 * Cashier search module definition.
 */
const cashierSearchModule = angular.module('cashierSearch.module', []);

cashierSearchModule.directive('cashierSearch', cashierSearchDirective);
cashierSearchModule.constant('cashierSearchConstant', cashierSearchConstant);

export default cashierSearchModule;



// WEBPACK FOOTER //
// ./src/app/core/components/cashierSearch/cashierSearch.module.js